import axiosInstance from "./AxiosConfig";

class DbBackupApiService {
  async DownloadBackup() {
    const response = await axiosInstance.get("/dbBackup/download", {
      responseType: "blob",
      timeout: 30 * 60 * 1000,
    });
    return response;
  }
}

export default new DbBackupApiService();
